import { render, staticRenderFns } from "./mainBranch.vue?vue&type=template&id=577da75e&scoped=true"
import script from "./mainBranch.vue?vue&type=script&lang=js"
export * from "./mainBranch.vue?vue&type=script&lang=js"
import style0 from "./mainBranch.vue?vue&type=style&index=0&id=577da75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577da75e",
  null
  
)

export default component.exports